import loadable from "@loadable/component"

import BaseLayout from "@mkt/ui/layouts/BaseLayout"
import useAnalytics from "@mkt/ui/hooks/useAnalytics"
import { track } from "@mkt/analytics/redline"

import GlobalError from "@mkt/cp/src/components/GlobalError"

import { HeaderCP, FooterCP } from "iq-blueberry"

import { colorsCP } from "../../styles/Tokens"
import customGlobalCss from "../../styles/customGlobalCss"

import useSeo from "../hooks/useSeo"
import * as S from "./styles"
import "iq-blueberry/dist/styles.css"

const BannerAlert = loadable(() => import("@mkt/cp/src/components/BannerAlert"))

const DefaultLayout = ({ children, pageContext, location }) => {
  const SEOProps = useSeo({ pageContext, location })
  const { trackClicksOnApp } = useAnalytics()
  const isLoans = location?.pathname?.includes("emprestimo")

  function formatMenu(data) {
    const mappedMenu = data.map((item) => {
      if (!isLoans && item.ariaLabel === "cartões de crédito")
        item.isActive = true
      return item
    })

    return mappedMenu
  }

  function trackLink(payload) {
    track("elementClicked", {
      webElement: { ...payload },
    })
  }

  switch (pageContext?.layout) {
    case "widget":
      return <div>{children}</div>
    default:
      return (
        <BaseLayout
          theme={colorsCP}
          customGlobalCss={customGlobalCss}
          appLayout={S.appLayout}
          trackClicksOnApp={trackClicksOnApp}
          SEOProps={{ ...SEOProps }}
        >
          <HeaderCP
            loginLink={APP_SCORE_URL}
            mapLoggedOutMenuItems={formatMenu}
          />

          <main css={S.mainContent} role="main">
            {children}
          </main>
          <FooterCP handleClick={trackLink} />
          <BannerAlert />
          <GlobalError />
        </BaseLayout>
      )
  }
}

export default DefaultLayout
